<template>
  <p v-bind="$attrs" class="text-h1">
    <slot></slot>
  </p>
</template>

<script>
export default {
}
</script>
